/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ConfigurationStore } from '../configuration-store';

export const ConfigurationStoreContext = createContext<ConfigurationStore>({} as ConfigurationStore);
